import React, { useState, useEffect } from 'react'
import CreateStudentModal from '../components/CreateStudentModal'
import apiClient from '../api/apiClient'
import {useAuth} from '../context/AuthContext.js'

export default function StudentCreatePage(){
    const {user} = useAuth()
    const schoolID = user.scId

    console.log(`and schoolID is ${schoolID}`)

    const [showStudentModal, setShowStudentModal] = useState(false)
    const [students, setStudents] = useState([])
    const [loading, setLoading] = useState(true)
    const [searchTerm, setSearchTerm] = useState('')
    const [editingStudent,setEditingStudent] = useState(null)

    async function handleCreate(data) {
        try{
            await apiClient.post('/api/students', data)
            fetchStudents()
            setShowStudentModal(false)
            //alert(`Kursist oprettet!\n`)  Lidt meget ekstra
        }catch(err){
            alert(err.response?.data?.message || 'Fejl ved oprettelse');
        }
    }

    async function fetchStudents(){
        try{
            setLoading(true)
            const res = await apiClient.get('/api/students/getall', {
                params: {schoolID: schoolID}
            })
            setStudents(res.data)
            setLoading(false)
        }catch(err){
            console.log("error in fetchStudents", err)
            setLoading(false)
        }
    }

    useEffect(()=>{
        fetchStudents()
    },[])

    const filteredStudents = students.filter(s => {
        const fullName = `${s.fornavne} ${s.efternavn}`.toLowerCase();
        const search = searchTerm.toLowerCase();
        return fullName.includes(search) || s.email?.toLowerCase().includes(search);
    });

    function handleEditClick(student){
        setEditingStudent(student)
    }

    return(
        <div>
            <div className="table-card">
                <div className="filter-bar">
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Søg på navn eller email..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button style={{
                        backgroundColor: '#003366', color: 'white', padding: '10px 20px',
                        border: 'none', borderRadius: '8px', cursor: 'pointer'
                    }} onClick={() => setShowStudentModal(true)}>
                        + Opret Kursist
                    </button>
                </div>

                {loading ? (
                    <p>Henter data...</p>
                ) : (
                    <table className="censor-table">
                        <thead>
                            <tr>
                                <th style={{width: '20%'}}>Fornavn(e)</th>
                                <th style={{width: '15%'}}>Efternavn</th>
                                <th style={{width: '25%'}}>Adresse</th>
                                <th style={{width: '8%'}}>Postnummer</th>
                                <th style={{width: '12%'}}>By</th>
                                <th style={{width: '8%'}}>Land</th>
                                <th style={{width: '7%'}}>Studie</th>
                                <th style={{width: '5%'}}>Handling</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredStudents.map((s) => (
                                <tr key={s.id}>
                                    <td><strong>{s.fornavne}</strong></td>
                                    <td>{s.efternavn}</td>
                                    <td>
                                        <div>{s.vejnavn} {s.husnummer}</div>
                                    </td>
                                    <td>{s.postnummer}</td>
                                    <td>{s.by}</td>
                                    <td>{s.land}</td>
                                    <td>{s.studie}</td>
                                    <td>
                                        <button onClick={()=>handleEditClick()}
                                            style={{
                                                background: 'none', border: '1px solid #ddd',
                                                padding: '5px 10px', borderRadius: '4px', cursor: 'pointer'
                                            }}
                                        >
                                            Rediger
                                        </button>
                                    </td>
                                </tr>
                            ))}

                            {filteredStudents.length === 0 && (
                                <tr>
                                    <td colSpan="8" style={{textAlign: 'center', padding: '2rem', color: '#888'}}>
                                        Ingen kursister fundet.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
            {showStudentModal &&
                <CreateStudentModal
                    schoolID = {schoolID}
                    onCreate={handleCreate}
                    onClose={() => setShowStudentModal(false)}
                />
            }
        </div>
    )
}
